import type {SceneObjectWithColorData} from "../_types/SceneObjectWithColorData";
import type {WebGLRenderObject} from "../_types/WebGLRenderObject";
import {ColorObjectPass} from "./passes/color/ColorObjectPass";
import {ScaleObjectPass} from "./passes/ScaleObjectPass";

export interface ObjectPipelinePass {
    apply(
        index: number,
        object: WebGLRenderObject,
        sceneObjects: Array<SceneObjectWithColorData>
    ): void;
}

export class ObjectPipeline {

    private passes: Array<ObjectPipelinePass> = [];

    constructor() {}

    // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
    public apply(
        objects: Array<WebGLRenderObject>,
        sceneObjects: Array<SceneObjectWithColorData>
    ): void {

        this.passes = this.passes.sort(
            (a, b) => getObjectPipelinePassPriority(a) - getObjectPipelinePassPriority(b));

        objects
            .forEach((object, i) => this.passes
                .forEach(pass => pass.apply(i, object, sceneObjects)));
    }

    // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
    public addPass(pass: ObjectPipelinePass): void {
        this.passes.push(pass);
    }
}

const getObjectPipelinePassPriority = (pass: ObjectPipelinePass) => {
    if (pass instanceof ColorObjectPass) return 2;
    if (pass instanceof ScaleObjectPass) return 1;
    return 0;
};